import {
  Heading,
  List,
  Text,
  Stack,
  Button,
  Card,
  IconTick,
  Badge,
} from 'braid-design-system';

interface MobilePackageTilesProps {
  onFreemiumClick: () => void;
  onStandardClick: () => void;
  onAccelerateClick: () => void;
  htags: {
    freemium: string;
    standard: string;
    accelerate: string;
  };
}

export const MobilePackageTiles = (props: MobilePackageTilesProps) => (
  <Stack space="large">
    <Card data={{ testid: 'mobile-package-tile-freemium' }}>
      <Stack space="medium">
        <Stack space="small">
          <Heading level="3">Free</Heading>

          <Text tone="secondary">Starting your selling journey</Text>
        </Stack>

        <List type="icon" icon={<IconTick />}>
          <Text>Appear on Australia&apos;s #1 business marketplace</Text>
          <Text>Receive emails from interested buyers</Text>
          <Text>List for 6 months</Text>
        </List>

        <Button
          tone="formAccent"
          onClick={props.onFreemiumClick}
          data={{ htag: props.htags.freemium }}
        >
          Choose Free
        </Button>
      </Stack>
    </Card>

    <Card data={{ testid: 'mobile-package-tile-standard' }}>
      <Stack space="medium">
        <Stack space="small">
          <Heading level="3">Standard</Heading>

          <Text tone="secondary">Get noticed by more buyers</Text>
        </Stack>

        <Badge tone="promote">Recommended</Badge>

        <Stack space="small" data={{ testid: 'package-price' }}>
          <Heading level="2">$949</Heading>

          <Text size="small">+ GST</Text>
        </Stack>

        <Stack space="small">
          <Text weight="strong">Everything in Free, plus:</Text>

          <List type="icon" icon={<IconTick />}>
            <Text>List until your business sells</Text>
            <Text>Photo included in search results</Text>
            <Text>Appear higher in search results</Text>
            <Text>Included in daily buyer recommendation emails</Text>
          </List>
        </Stack>

        <Button
          tone="formAccent"
          onClick={props.onStandardClick}
          data={{ htag: props.htags.standard }}
        >
          Choose Standard
        </Button>
      </Stack>
    </Card>

    <Card data={{ testid: 'mobile-package-tile-accelerate' }}>
      <Stack space="medium">
        <Stack space="small">
          <Heading level="3">Accelerate</Heading>

          <Text tone="secondary">Reach the right buyers faster</Text>
        </Stack>

        <Stack space="small" data={{ testid: 'package-price' }}>
          <Heading level="2">$1299</Heading>
          <Text size="small">+ GST</Text>
        </Stack>

        <Stack space="small">
          <Text weight="strong">Everything in Standard, plus:</Text>

          <List type="icon" icon={<IconTick />}>
            <Text>Feature at the top of search results</Text>
            <Text>Priority placement in daily buyer recommendation emails</Text>
          </List>
        </Stack>

        <Button
          tone="formAccent"
          onClick={props.onAccelerateClick}
          data={{ htag: props.htags.accelerate }}
        >
          Choose Accelerate
        </Button>
      </Stack>
    </Card>
  </Stack>
);
